import React from 'react';
import PropTypes from 'prop-types';
import { formValues } from 'redux-form';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { setModal } from 'actions';
import dataForm from 'components/dataForm';
import { ChoiceField, TextField } from 'components/form/field';
import { GridLayout } from 'components/form/layout';
import { contactOriginAsLabelChoices, OTHER_CONTACT_ORIGIN_LABEL } from 'common/utils/contactOrigin';
import { useSettings } from '../sessions';

const EditContactOriginForm = ({ handleSubmit, close, contactOrigin }) => {
    const contactOriginTypes = contactOriginAsLabelChoices(useSettings('global.contactOriginTypes'));

    return (
        <form onSubmit={handleSubmit}>
            <GridLayout className="single condensed full-width">
                <ChoiceField choices={contactOriginTypes} title="Origine du contact" name="contactOrigin" />
                {
                    OTHER_CONTACT_ORIGIN_LABEL === contactOrigin ? (
                        <TextField title="Précisez" name="contactOriginOther" />
                    ) : null
                }
            </GridLayout>
            <div className="submit-footer">
                <div>
                    <button type="button" className="cancel-button" onClick={close}>
                        Annuler
                    </button>
                </div>
                <div>
                    <button type="submit" className="submit-button">
                        Continuer
                    </button>
                </div>
            </div>
        </form>
    );
};

EditContactOriginForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    contactOrigin: PropTypes.string.isRequired,
};

export default compose(
    connect(null, (dispatch) => ({
        close: () => dispatch(setModal(null)),
    })),
    dataForm({
        form: 'rip-edit-contact-origin-form',
        autoSave: false,
        type: 'rip',
        id: ({ id }) => id,
        onSubmitSuccess: (result, dispatch, { close, onSuccess }) => {
            if (onSuccess) {
                onSuccess(result);
            }

            close();
        },
    }),
    formValues({ contactOrigin: 'contactOrigin' }),
)(EditContactOriginForm);
